export const LANDING_FB_APP_ID = 866755860444110

// https://developers.facebook.com/docs/instagram/oembed
// https://developers.facebook.com/apps/
const IG_APP_ID = 736077967293187
const IG_APP_ACCESS_TOKEN = 'fc62b9b0913cf2b3bcbf57c5b3f26991'
export const LANDING_IG_ACCESS_TOKEN = `${IG_APP_ID}|${IG_APP_ACCESS_TOKEN}`
